<template>
  <div class="container container-fluid">
    <div v-if="showComponentData" class="row mt-3">
      <div class="text-left pt-4">
        <h4>Datos Siniestro</h4>
      </div>
      <!-- FECHA DE OCURRENCIA -->
      <div v-if="isFieldVisible('happn_date')" class="col-md-3 mt-3">
        <div class="form-group bordered">
          <label for="happn_date" class="form-label text-left">{{ getFieldDescription('happn_date') }}</label>
          <input
            type="date"
            class="form-control"
            name="happn_date"
            v-model="formData.happn_date"
            required="required"
            @input="() => emitFieldChanged('happn_date')"
          />
        </div>
      </div>
      <!-- TIPO DE SINIESTRO -->
     <!--  <div v-if="isFieldVisible('sinester_type')" class="col-md-3 mt-3">
        <div class="form-group bordered">
          <label for="sinester_type" class="form-label text-left">{{ getFieldDescription('sinester_type') }}</label>
          <input
            type="text"
            class="form-control"
            name="sinester_type"
            v-model="formData.sinester_type"
            required="required"
            maxlength="150"
            @input="() => emitFieldChanged('sinester_type')"
          />
        </div>
      </div> -->
      <!-- RELATO DEL HECHO -->
      <div v-if="isFieldVisible('happn_text')" class="col-md-3 mt-3">
        <div class="form-group bordered">
          <label for="happn_text" class="form-label text-left">{{ getFieldDescription('happn_text') }}</label>
          <textarea
            class="form-control"
            id="happn_text" 
            v-model="formData.happn_text"
            required="required"
            @input="() => emitFieldChanged('happn_text')"
          ></textarea>
        </div>
      </div>
      <!-- BIENES AFECTADOS -->
      <div v-if="isFieldVisible('affected_stuffs')" class="col-md-3 mt-3">
        <div class="form-group bordered">
          <label for="affected_stuffs" class="form-label text-left">{{ getFieldDescription('affected_stuffs') }}</label>
          <textarea
            class="form-control"
            id="affected_stuffs"
            v-model="formData.affected_stuffs"
            required="required"
            @input="() => emitFieldChanged('affected_stuffs')"
          ></textarea>
        </div>
      </div>
      <!-- DAÑO ESTIMADO -->
      <div v-if="isFieldVisible('estimated_damage')" class="col-md-3 mt-3">
        <label for="estimated_damage" class="form-label text-left">{{ getFieldDescription('estimated_damage') }}</label>
        <div class="input-group bordered">
          <span class="input-group-text">$</span>
          <input 
          type="text" 
          class="form-control"
          name="estimated_damage"
          v-model="formData.estimated_damage"
          required="required"
          maxlength="255"
          @input="() => emitFieldChanged('estimated_damage')"
          >
          <span class="input-group-text ">,00</span>
        </div>
      </div>
      <!-- EL ASEGURADO ERA EL CONDUCTOR? -->
      <div v-if="isFieldVisible('insured_was_driver')" class="col-md-3 mt-3">
        <label for="estimated_damage" class="form-label text-left">{{ getFieldDescription('insured_was_driver') }}</label>
        <SelectTrueFalse
          class="form-control select-custom"
          :insured_was_driver="formData.insured_was_driver === 1"
          v-bind:data="selectedInsuredWasDrivers" 
          v-on:update:data="selectedInsuredWasDrivers = $event"
          @change="emitFieldChanged('insured_was_driver')"
          required="required"
        ></SelectTrueFalse>
      </div>
      <!-- NOMBRE Y APELLIDO CONDUCTOR -->
      <div v-if="selectedInsuredWasDrivers === false" class="col-md-3 mt-3">
        <label for="driver_name" class="form-label text-left">Nombre y Apellido</label>
        <div class="input-group bordered">
          <input
            type="text"
            class="form-control"
            name="driver_name"
            v-model="formData.driver_name"
            required="required"
            maxlength="191"
            @input="() => emitFieldChanged('driver_name')"
          />
        </div>
      </div>
      <!-- DNI CONDUCTOR -->
      <div v-if="selectedInsuredWasDrivers === false" class="col-md-3 mt-3">
        <label for="driver_dni" class="form-label text-left">DNI</label>
        <div class="input-group bordered">
          <input
            type="number"
            class="form-control"
            name="driver_dni"
            v-model="formData.driver_dni"
            required="required"
            maxlength="8"
            @input="() => emitFieldChanged('driver_dni')"
          />
        </div>
      </div>
       <!-- TEL CONDUCTOR -->
       <div v-if="selectedInsuredWasDrivers === false" class="col-md-3 mt-3">
        <label for="driver_phone" class="form-label text-left">Teléfono</label>
        <div class="input-group bordered">
          <input
            type="text"
            class="form-control"
            name="driver_phone"
            v-model="formData.driver_phone"
            required="required"
            maxlength="10"
            @input="() => emitFieldChanged('driver_phone')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import SelectTrueFalse from './selectDatos/SelectTrueFalse';

export default {
  name: 'FormPersonal',
  props: {
    data: Object,
  },
  components: {
    SelectTrueFalse,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const selectedInsuredWasDrivers = ref(true);
    const estimatedDamage = ref('');

    const formData = ref({
      happn_date: null,
      sinester_type: null,
      happn_text: null,
      affected_stuffs: null,
      estimated_damage: null,
      insured_was_driver: 0,
      driver_name: null,
      driver_dni: null,
      driver_phone: null,
      persons: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.happn_date ||
            dataCompany.value.sinester_type ||
            dataCompany.value.happn_text ||
            dataCompany.value.affected_stuffs ||
            dataCompany.value.estimated_damage ||
            dataCompany.value.insured_was_driver ||
            dataCompany.value.persons)
        );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFieldChanged = () => {
      const driverFields = ['driver_name', 'driver_dni', 'driver_phone'];
      const newFormData = { ...formData.value };
      if (newFormData.estimated_damage) {
        let value = newFormData.estimated_damage;
        value = value.replace(/\./g, '');
        value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        estimatedDamage.value = value;

        newFormData.estimated_damage = `$ ${estimatedDamage.value}`;
      }
      if (selectedInsuredWasDrivers.value === true) {
        driverFields.forEach(field => {
          newFormData[field] = null;
        });
      } else {
        newFormData.insured_was_driver = 1;
      }
      emit('formDataChanged', newFormData);
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      formData,
      emitFieldChanged,
      selectedInsuredWasDrivers,
      estimatedDamage
    };
  },
};
</script>
 
